// @flow

class PanNumber {
  constructor(number: string, valid: boolean) {
    this.number = number;
    this.valid = valid;
  }
}

PanNumber.prototype.validLength = '10';

PanNumber.prototype.inputType = 'text';

PanNumber.prototype.validRegex = '([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}';

PanNumber.prototype.validatePanNumber = (panNumber: PanNumber) =>
  panNumber &&
  panNumber.number &&
  panNumber.number.length === Number(PanNumber.prototype.validLength) &&
  panNumber.number.match(PanNumber.prototype.validRegex);

export default PanNumber;
